import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { motion } from "framer-motion";

export const KPICard = ({ 
  title, 
  value, 
  prefix = "", 
  suffix = "", 
  change, 
  changeLabel,
  icon: Icon,
  className,
  delay = 0,
  isRoas = false,
  roasThreshold = 1.75
}) => {
  const isPositiveChange = change > 0;
  const isNegativeChange = change < 0;
  
  // For ROAS, color based on threshold
  const getValueColor = () => {
    if (!isRoas) return "text-white";
    const numValue = parseFloat(value);
    if (numValue >= roasThreshold) return "text-emerald-400";
    if (numValue >= roasThreshold * 0.8) return "text-amber-400";
    return "text-red-400";
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className={cn(
        "bg-[#121212] border border-white/10 rounded-xl p-6 hover:border-white/20 transition-colors duration-300",
        className
      )}
    >
      <div className="flex items-start justify-between mb-4">
        <span className="text-xs uppercase tracking-widest text-zinc-400 font-medium">
          {title}
        </span>
        {Icon && (
          <div className="w-9 h-9 rounded-lg bg-white/5 flex items-center justify-center text-zinc-400">
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
      
      <div className="mb-2">
        <span className={cn("font-heading text-3xl font-bold tabular-nums", getValueColor())}>
          {prefix}{value}{suffix}
        </span>
      </div>
      
      {(change !== undefined || changeLabel) && (
        <div className="flex items-center gap-2">
          {change !== undefined && (
            <div className={cn(
              "flex items-center gap-1 text-sm font-medium",
              isPositiveChange ? "text-emerald-400" : isNegativeChange ? "text-red-400" : "text-zinc-400"
            )}>
              {isPositiveChange ? (
                <TrendingUp className="w-4 h-4" />
              ) : isNegativeChange ? (
                <TrendingDown className="w-4 h-4" />
              ) : (
                <Minus className="w-4 h-4" />
              )}
              <span>{Math.abs(change).toFixed(1)}%</span>
            </div>
          )}
          {changeLabel && (
            <span className="text-zinc-500 text-sm">{changeLabel}</span>
          )}
        </div>
      )}
    </motion.div>
  );
};
